import React from 'react';
import { Box } from '@hover/blueprint';
import PremiumFeatures from './PremiumFeatures';

const TabletAndDesktop: React.FC = () => (
  <Box d={{ base: 'none', tablet: 'flex' }} flexDir="column">
    <PremiumFeatures />
  </Box>
);

export default TabletAndDesktop;
